(function () {
  'use strict';

  angular
    .module('unit.type.change')
    .controller('unitTypeChangeCtrl', unitTypeChangeCtrl);

  unitTypeChangeCtrl.$inject = ['UnitTypeChange', '$translate', '$window'];

  function unitTypeChangeCtrl(UnitTypeChange, $translate, $window) {
    var vm = this;

    vm.request = {};
    vm.btnLoadingOn = false;

    vm.unitTypes = [
      {
        name_translated: $translate.instant(
          'leads.sidebar.main.where.type.group.main',
        ),
        msGroup: true,
        disabled: true,
      },
      {
        id: 2,
        value: 'apartment',
        name_translated: $translate.instant('unit.popup.apartment'),
      },
      {
        id: 3,
        value: 'commercial',
        name_translated: $translate.instant('unit.popup.commercial.unit'),
      },
      {
        id: 9,
        value: 'attic',
        name_translated: $translate.instant('unit.popup.attic'),
      },
      {
        id: 7,
        value: 'hotel-type',
        name_translated: $translate.instant('unit.popup.hotel.type'),
      },
      { msGroup: false },
      {
        name_translated: $translate.instant(
          'leads.sidebar.main.where.type.group.individual',
        ),
        msGroup: true,
        disabled: true,
      },
      {
        id: 13,
        value: 'cottage',
        name_translated: $translate.instant('unit.popup.cottage'),
      },
      {
        id: 6,
        value: 'townhouse',
        name_translated: $translate.instant('unit.popup.townhouse'),
      },
      {
        id: 12,
        value: 'duplex',
        name_translated: $translate.instant('unit.popup.duplex'),
      },
      {
        id: 5,
        value: 'plot',
        name_translated: $translate.instant('unit.popup.land.plot'),
      },
      {
        id: 4,
        value: 'villa',
        name_translated: $translate.instant('unit.popup.villa'),
      },
      { msGroup: false },
      {
        name_translated: $translate.instant(
          'leads.sidebar.main.where.type.group.other',
        ),
        msGroup: true,
        disabled: true,
      },
      {
        id: 8,
        value: 'store-room',
        name_translated: $translate.instant('unit.popup.store.room'),
      },
      {
        id: 10,
        value: 'parking-lot',
        name_translated: $translate.instant('unit.popup.parking.lot'),
      },
      {
        id: 11,
        value: 'pavement-parking',
        name_translated: $translate.instant('unit.popup.pavement.parking'),
      },
      { msGroup: false },
    ];

    vm.changeAll = function (typeId) {
      vm.btnLoadingOn = true;
      UnitTypeChange.updateType(
        {},
        {
          typeId: typeId,
          sectionId: vm.sectionId,
        },
        function (resp) {
          vm.btnLoadingOn = false;
          $window.location.reload();
        },
        function (resp) {
          vm.btnLoadingOn = false;
          console.log('error');
        },
      );
    };
  }
})();
